import { Component, OnInit, AfterViewInit, OnDestroy, HostListener, Input } from '@angular/core';
import { Router, NavigationEnd, NavigationStart, NavigationError } from '@angular/router';
import { DrawingToolService } from '../../services/drawingtool.service';

declare var createjs: any;
import * as $ from "jquery";
declare const InstallTrigger: any;
@Component({
  selector: 'app-drawing-tool',
  templateUrl: './drawing-tool.component.html',
  styleUrls: ['./drawing-tool.component.scss']
})
export class DrawingToolComponent implements OnInit, AfterViewInit, OnDestroy {

  @HostListener('document:keyup', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {
    var textbox: any = document.getElementById("my_drawing_tool_text");
    if (textbox && textbox != "") {
      var can_text = textbox.textContent;      
      if (can_text && can_text != "") {
        var textbox1: any = document.getElementById("search_field");
        textbox1.value = can_text;
      }
    }
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    var thisme = this;   
    setTimeout(function () {
      thisme.drawingtoolService.reset_drawing_tool_after_resize();
      thisme.drawingtoolService.reset_textbox_after_resize();      
      thisme.drawingtoolService.drawing_canvas_resizing();
    }, 100);
  }



  isEdge: any = navigator.userAgent.indexOf(' Edge/') >= 0 || navigator.userAgent.indexOf(' edge/') >= 0;
  isFirefox: any = typeof InstallTrigger !== 'undefined';
  isiPad: any = (navigator.userAgent.match(/iPad/i) != null);
  isChrome: any = /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);
  isSafari: any = navigator.userAgent.indexOf("Safari") > -1;
  isIE: any = !!navigator.userAgent.match(/Trident/g) || !!navigator.userAgent.match(/MSIE/g);
  isMac: any = navigator.platform.indexOf('Mac') > -1;
  componentName: string;

  public eraser: any = [];
  public shapes: any = [];
  public colorpicker: any = [];
  public text: any = [];
  public menudata: any = [];
  public currentpage = "";


  @Input() c_section: string;
  @Input() c_bookname: string;

  constructor(public drawingtoolService: DrawingToolService, private router: Router) {
    this.eraser = drawingtoolService.eraser['sub'];
    this.shapes = drawingtoolService.shapes['sub'];
    this.colorpicker = drawingtoolService.colorpicker['sub'];
    this.text = drawingtoolService.text['sub'];
    this.menudata = drawingtoolService.menudata;
    
    window['drawingtoolService'] = this.drawingtoolService;

    var thisme = this;
    router.events.subscribe((val) => {
      if (val instanceof NavigationStart) {      
        thisme.drawingtoolService.wp_btnOkClick('');
      }
    });
  }


  ngOnInit() {
    var thisme = this;
    setTimeout(function () {
      thisme.drawingtoolService.loadDrawingTool(thisme.c_section, thisme.c_bookname);
      thisme.drawingtoolService.loadCSS();
      thisme.currentpage = `${thisme.c_section}_${thisme.c_bookname}`;
      window['wpaint_canvas'] = thisme.drawingtoolService.canvas;
    }, 100);
  }
  async ngAfterViewInit() {
    this.drawingtoolService.loadJS();
  }

  ngOnDestroy() {
    this.clearDrawingToolCache();
  }


  clearDrawingToolCache() {
    this.drawingtoolService.resetMenu();
  }

  leftclick(tabname, hide_right_arrow) {
    this.drawingtoolService.leftclick(tabname, hide_right_arrow);
  }
  rightclick(tabname, hide_right_arrow) {
    this.drawingtoolService.rightclick(tabname, hide_right_arrow);
  }


  dragKeyboard() {

    var keyboardboundary = [];

    if (this.isChrome == true) {
      if (screen.width == 1920 && screen.height == 1080) {
        keyboardboundary = [45, 115, 1485, 688];
      }
    } else if (this.isFirefox == true) {
      if (screen.width == 1920 && screen.height == 1080) {
        keyboardboundary = [45, 115, 1485, 688];
      }
    } else if (this.isIE == true) {
      if (screen.width == 1920 && screen.height == 1080) {
        keyboardboundary = [45, 115, 1485, 688];
      }
    } else if (this.isEdge == true) {
      if (screen.width == 1920 && screen.height == 1080) {
        keyboardboundary = [45, 115, 1485, 688];
      }
    }

  }

  keyboardToggle(status) {
    this.drawingtoolService.keyboardToggle(status)

  }

  cleanExercise(e) {


    this.drawingtoolService.wp_btnOkClick(e);
  }

}
